class MegaMenuPanel extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-mega-category]'));
    this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
    this.activeHandle = this.triggers.find((trigger) => trigger.classList.contains('is-active'))
      ?.dataset.megaCategory;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => this.activate(trigger.dataset.megaCategory));
      trigger.addEventListener('focus', () => this.activate(trigger.dataset.megaCategory));
    });
  }

  activate(handle) {
    if (!handle || handle === this.activeHandle) return;
    this.activeHandle = handle;

    this.triggers.forEach((trigger) => {
      const isActive = trigger.dataset.megaCategory === handle;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.megaPanel === handle;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      panel.toggleAttribute('inert', !isActive);
    });
  }
}

customElements.define('mega-menu-panel', MegaMenuPanel);

class MegaMenuHover {
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = this.summary?.nextElementSibling;
    this.closeTimeout = null;
    this.mediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (!this.summary || !this.content) return;
    if (!this.mediaQuery.matches) return;

    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.details.addEventListener('mouseenter', this.onEnter);
    this.details.addEventListener('mouseleave', this.onLeave);
    this.content.addEventListener('mouseenter', this.onEnter);
    this.content.addEventListener('mouseleave', this.onLeave);
    this.summary.addEventListener('click', this.onSummaryClick);
  }

  onSummaryClick(event) {
    // Keyboard activation (Enter/Space) still toggles normally.
    if (event.detail === 0) return;
    // Hover already opens the menu; prevent mouse click from immediately closing it.
    event.preventDefault();
  }

  onEnter() {
    window.clearTimeout(this.closeTimeout);
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');

    const header = document.querySelector('.header-wrapper');
    if (header) header.preventHide = true;
  }

  onLeave() {
    this.closeTimeout = window.setTimeout(() => {
      this.details.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', 'false');

      const header = document.querySelector('.header-wrapper');
      if (header) header.preventHide = false;
    }, 120);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('details.mega-menu[data-mega-menu]').forEach((details) => {
    new MegaMenuHover(details);
  });
});
